module.exports = __webpack_public_path__ + "static/media/dental_icon.fe55f1b8.png";